import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'

export default PhoneInput
